// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".modal-wrapper[data-v-73c4c5af]{z-index:52;--tw-bg-opacity:1;background-color:rgba(33, 22, 111, var(--tw-bg-opacity));--tw-bg-opacity:0.75;position:fixed;top:0;right:0;bottom:0;left:0;display:flex;align-items:center;justify-content:center}.modal-content[data-v-73c4c5af]{position:relative;width:90%;max-height:90%;min-height:350px;max-width:768px;overflow-y:scroll}@media (min-width: 1024px){.modal-content[data-v-73c4c5af]{overflow-y:visible}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
